import axios from "axios";

//const API = axios.create({ baseURL: "http://localhost:5001", withCredentials: true });
const API = axios.create({ baseURL: "https://api.themaingategroup.com", withCredentials: true });

export const verifyTwoFactCode = (info, token) => API.post("/customer/verifytwofactorcode", { info: info, token });
export const updateTwoFactorSecurity = (info, token) => API.post("/customer/updatesecurity", { info: info, token });
export const getTwoFactorInfoSecurity = (email, token) => API.post("/customer/gettwofactorinfo", { email: email, token });
